import React from "react";
import { Outlet } from "react-router-dom";
import FinanceSidebar from "./FinanceSidebar";

const Finance = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "calc(100vh - 48px)",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <FinanceSidebar />

      <div
        className="finance-content-scroll"
        style={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Finance;
